export const AMAZON_RE = new RegExp('^(https?:)?//((www.amazon(.[a-z]{2,3}){1,2})|amzn.to)/');
export const AMAZON_PUBLISHER_ADS_RE = new RegExp('^https?://prod.ozone.publishers.advertising.a2z.com');
export function isAmazonUrl(url) {
    if (url instanceof URL) {
        return isAmazonUrl(url.href);
    }
    return AMAZON_RE.test(url) || AMAZON_PUBLISHER_ADS_RE.test(url);
}
/**
 * Extract an amazon ASIN from an amazon url
 */
export function extractAsinFromUrl(url) {
    try {
        let formatted = new URL(url);
        // check for the beta redirect url format
        if (formatted.host.includes('prod.ozone.publishers.advertising.a2z.com')) {
            const subUrl = formatted.searchParams.get('rUrl');
            if (subUrl === null) {
                return undefined;
            }
            formatted = new URL(subUrl);
        }
        if (formatted.host.includes('amazon.')) {
            const identified = formatted.pathname.match('(([dg]p|product)/([A-Z0-9]{10}))');
            return identified === null ? undefined : identified[3];
        }
    }
    catch {
        /* no op */
    }
    return undefined;
}
/**
 * Extract the existing Amazon partner tag from a url
 */
export function extractAscTagFromUrl(url) {
    try {
        const formatted = new URL(url);
        const matches = formatted.search.match(/tag=(?<tag>[a-zA-Z0-9_-]+)/);
        if (matches) {
            return matches.groups?.tag;
        }
    }
    catch {
        /* no op */
    }
    return undefined;
}
export function extractAmazonTagFromUrl(url) {
    // Only proceed if it's an Amazon URL...
    if (!isAmazonUrl(url)) {
        return undefined;
    }
    // Now we can go ahead and extract the tag
    try {
        if (typeof url === 'string') {
            url = new URL(url);
        }
        return url.searchParams.get('tag') ?? undefined;
    }
    catch (e) {
        console.error(`Could not extract Amazon tag from URL ${url.toString()}`);
        return undefined;
    }
}
export function replaceAmazonTagInUrl(origUrl, newTag) {
    // Only proceed if it's an Amazon URL...
    if (!isAmazonUrl(origUrl)) {
        return origUrl;
    }
    // Now we can go ahead and replace it
    let newUrl;
    try {
        // Get protocol-relative URL to parse
        if (origUrl.startsWith('//')) {
            origUrl = `https:${origUrl}`;
        }
        newUrl = new URL(origUrl);
        // or a manually added tag that's not the page/site tag
        const manualTag = newUrl.searchParams.get('tag');
        if (!newTag || (manualTag && manualTag !== newTag)) {
            return origUrl;
        }
        newUrl.searchParams.set('tag', newTag);
        return newUrl.toString();
    }
    catch (e) {
        console.error(`Could not parse URL ${origUrl}`);
        return origUrl;
    }
}
//# sourceMappingURL=amazonUtils.js.map